import { Box } from "@mui/material";
import AlertDisplay from "../../../../../components/BasicComponents/DisplayDados/AlertDisplay";
import { INotaFiscal } from "../../../../../types/api/fiscal/detalhe-nfe-entrada";
import moment from "moment";
import { useModalDetalheHistoricoRecebimento } from "../../../../Estoque/components/MIEntradaProdutos/ModalDetalheHistoricoRecebimentoContext";
import { useState } from "react";
import { DialogVerificacaoContabil } from "./DialogVerificacaoContabil";

export default function CardStatus({ fiscal }: PropsCardStatus) {

  const [openModalVerContabil, setOpenModalVerContabil] = useState(false);

  const handleCloseModalVerContabil = () => {
    setOpenModalVerContabil(false);
  };
  const handleOpenModalVerContabil = () => {
    setOpenModalVerContabil(true);
  };

  const formatarData = (data: string) => {
    return moment(data).format("DD/MM/YYYY HH:mm:ss");
  };

  const { openModal } = useModalDetalheHistoricoRecebimento();

  const handleVerRecebimento = () => {
    const idNotaFiscal = fiscal.recebimento_mercadoria_id;
    if (idNotaFiscal) {
      openModal(idNotaFiscal.toString());
    }
  };

  const status = fiscal.status_recebimento;

  return (
    <>
      <Box display="flex" flexDirection="column" gap={2}>
        {status === "Recebido com sucesso" && (
          <AlertDisplay
            titulo={status}
            registro={
              "Registrado em " +
              formatarData(fiscal.data_recebimento || "") +
              " por " +
              (fiscal.pessoa_recebimento || "")
            }
            acao="VER RECEBIMENTO"
            acaoCallback={handleVerRecebimento}
            color="success"
          />
        )}

        {status === "Aguardando aprovação fiscal" && (
          <AlertDisplay
            titulo={status}
            registro={"Aguardando aprovação fiscal para disponibilização do estoque"}
            acao="VER RECEBIMENTO"
            acaoCallback={handleVerRecebimento}
            color="warning"
          />
        )}

        {status === "Aguardando" && (
          <AlertDisplay
            titulo={status}
            registro={"Nota fiscal não recebida"}
            color="warning"
          />
        )}
        {status === "Análise de divergência" && (
          <AlertDisplay
            titulo="Análise de Divergência"
            registro={"Erro na análise, encaminhado para análise de Divergência"}
            color="error"
          />
        )}
        {status === "Recebido com sucesso" && (
          <AlertDisplay
            titulo="Aprovação fiscal"
            registro={"Aprovação fiscal realizada com sucesso"}
            color="success"
          />
        )}
        {status === "Aguardando aprovação fiscal" && (
          <AlertDisplay
            titulo="Aprovação fiscal"
            registro={"Aguardando aprovação fiscal"}
            acao="APROVAR"
            color="warning"
            acaoCallback={handleOpenModalVerContabil}
          />
        )}
        {status === "Análise de divergência" && (
          <AlertDisplay
            titulo="Análise de Divergência"
            registro={"Análise de Divergência"}
            color="error"
          />
        )}

      </Box>
      {
        openModalVerContabil &&
        <DialogVerificacaoContabil
          open={openModalVerContabil}
          fiscal={fiscal}
          handleClose={handleCloseModalVerContabil}
        />
      }

    </>
  );
}

interface PropsCardStatus {
  fiscal: INotaFiscal;
}